export default function CarouselPrev() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="41" height="40" viewBox="0 0 41 40" fill="none">
        <circle cx="20.5" cy="20" r="19.25" strokeWidth="1.5"/>
        <path d="M22.5 14L16.5 20L22.5 26" strokeWidth="1.5"/>
    </svg>
  );
}
